import { render, staticRenderFns } from "./ShowExp.vue?vue&type=template&id=2a0c7818"
import script from "./ShowExp.vue?vue&type=script&lang=js"
export * from "./ShowExp.vue?vue&type=script&lang=js"
import style0 from "./ShowExp.vue?vue&type=style&index=0&id=2a0c7818&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports